export default __webpack_public_path__ + "static/media/FiraSansExtraCondensed-SemiBold.c3f7daf9.ttf";